/**
 * Shell-level overlays: the ⌘K palette and the `?` keyboard cheat sheet.
 *
 * Module-level refs rather than props, because both are opened from places with
 * no relationship to the shell — a command inside the palette, a button in a
 * list toolbar, a global shortcut registered by a view.
 */

import { ref, type Ref } from 'vue'

import { onSessionEnd } from '@/lib/sessionReset'

const paletteOpen = ref(false)
const cheatSheetOpen = ref(false)

/*
 * Neither overlay belongs to the next person: the shell re-mounts them from
 * these flags on the next sign-in, so a palette the previous person left open
 * would greet whoever signs in next (`lib/sessionReset.ts`).
 */
onSessionEnd(() => {
  paletteOpen.value = false
  cheatSheetOpen.value = false
})

export interface Overlays {
  paletteOpen: Ref<boolean>
  cheatSheetOpen: Ref<boolean>
  openPalette: () => void
  openCheatSheet: () => void
  closeAll: () => void
}

export function useOverlays(): Overlays {
  return {
    paletteOpen,
    cheatSheetOpen,
    openPalette: () => {
      paletteOpen.value = true
    },
    openCheatSheet: () => {
      cheatSheetOpen.value = true
    },
    closeAll: () => {
      paletteOpen.value = false
      cheatSheetOpen.value = false
    },
  }
}
